import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';

import { ErrorComponent } from '../../components/ErrorComponent';
import { selectRecommendations } from '../../selectors/recommendations';

export const ErrorContainer: React.FC = () => {
  const deviceType = useDeviceType();
  const recommendations = useSelector(selectRecommendations);

  const handleClick = React.useCallback(() => {
    window.location.reload();
  }, []);

  if (recommendations.length > 0) {
    return null;
  }

  return <ErrorComponent deviceType={deviceType} onClick={handleClick} />;
};
